<script>
  import options from './CreateFrivilligeProfile.options'
  export default options
</script>

<template>
  <article class="kb-stafet-donation-flow kb-stafet-step kb-optimizely-forms kb-create-frivillige-profile">
    <article class="kb-stafet-flow-title">
      <h1 class="kb-stafet-flow-title__title">{{ getLabel('title') }}</h1>
      <div class="kb-stafet-flow-title__breaker">
        <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z"></path></svg>
      </div>
      <div class="kb-stafet-flow-title__description">
        <p class="kb-stafet-flow-title__description-text">{{ getLabel('description') }}</p>
      </div>
    </article>


    <div class="kb-stafet-donation-flow__step">
      <div class="kb-stafet-step__input-wrapper">
        <h2 class="kb-stafet-step__step-section-title">{{ getLabel("userInformationTitle") }}</h2>
        
        <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
            <FormInputNameField
              isRequired
              v-model="firstName"
              :modelValue="firstName"
              fieldName="firstName"
              :label="getLabel('firstNameLabel')"
              :placeholder="getLabel('firstNamePlaceholder')"
              :isValidationError="displayError && !nameValidator(firstName)"
              :errorMessageLabel="getLabel('firstNameErrorLabel')"
              :readOnly="isReadOnly.firstName"
            />

            <FormInputNameField
              isRequired
              v-model="lastName"
              :modelValue="lastName"
              fieldName="lastName"
              :label="getLabel('lastNameLabel')"
              :placeholder="getLabel('lastNamePlaceholder')"
              :isValidationError="displayError && !nameValidator(lastName)"
              :errorMessageLabel="getLabel('lastNameErrorLabel')"
              :readOnly="isReadOnly.lastName"
            />

          </div>

            <FormAddressField
              v-model:address-line-value="address"
              v-model:zip-code-value="postalCode"
              v-model:city-value="city"
              :addressPlaceholder="getLabel('addressLinePlaceholder')"
              :zipCodePlaceholder="getLabel('postalCodePlaceholder')"
              :cityPlaceholder="getLabel('cityPlaceholder')"
              :addressLabel="getLabel('addressLineLabel')"
              :zipCodeLabel="getLabel('postalCodeLabel')"
              :cityLabel="getLabel('cityLabel')"
              :isValidationError="displayError && !addressValidator(address, postalCode, city)"
              :errorMessageLabel="getLabel('addressErrorLabel')"
              :disabled="isReadOnly.address"
            />

            <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
              <FormInputPhoneField
                isRequired
                v-model="phoneNumber"
                :modelValue="phoneNumber"
                fieldName="phoneNumber"
                :label="getLabel('phoneNumberLabel')"
                :placeholder="getLabel('phoneNumberPlaceholder')"
                :isValidationError="displayError && !phoneValidator(phoneNumber)"
                :errorMessageLabel="getLabel('phoneNumberErrorLabel')"
                :readOnly="isReadOnly.phoneNumber"
              />


              <FormInputTextField
                isRequired
                :readOnly="true"
                type="email"
                v-model="email"
                :modelValue="email"
                fieldName="email"
                :label="getLabel('emailLabel')"
                :placeholder="getLabel('emailPlaceholder')"
                :isValidationError="displayError && !emailValidator(email)"
                :errorMessageLabel="getLabel('emailErrorLabel')"
              />
            </div>

            <FormCheckbox
              fieldName="consentBool"
              :modelValue="consentBool.toString()"
              v-model="consentBool"
              :label="getLabel('consentBoolLabel')"
              :isRichText="true"
              :isValidationError="displayError && !consentBool"
              :errorMessageLabel="getLabel('consentBoolErrorLabel')"
              :onChangeCallback="(e) => consentBool = e.target.checked"
            /> 

             <FormCheckbox 
              fieldName="newsletterBool"
              :modelValue="newsletterBool.toString()"
              v-model="newsletterBool"
              :label="getLabel('newsletterBoolLabel')"
              :onChangeCallback="(e) => newsletterBool = e.target.checked"
            />
      </div>

      <article class="kb-stafet-flow-actions">
        <div class="kb-stafet-flow-actions__buttons-wrapper">
            <button 
              class="kb-button kb-button--full-color-spot"
              :class="{
                'kb-button--disabled': isSubmitting
              }"
              v-on:click="submit">
              {{ getLabel('submitButtonText') }}
            </button> 
          </div>
      </article>
      
      <template v-if="isSubmitting">
        <div class="kb-spinner-overlay">
          <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
        </div>
      </template>
      
    </div>
  </article>
</template>
